import React from 'react';
import { useSelector } from 'react-redux';
import { JoystickViewProps } from './types';
import { useJoystick } from '@src/features/order/pages/take-off-to-en-route-page/hooks';
import { ArcCellInfo, ArcDivider, ArcStack, ArcText } from '@src/core/ui';
import { selectJoystickStatus, selectJoystickId } from '@src/features/order/pages/checklist-page/redux';

const JoystickView: React.FC<JoystickViewProps> = (props) => {
  const { drone, isManualControl } = props;

  const { connected, joystickId, axes, buttons } = useJoystick(drone?.serialNumber, isManualControl);
  
  // Get saved status from Redux
  const savedConnected = useSelector(selectJoystickStatus(drone?.serialNumber || ''));
  const savedJoystickId = useSelector(selectJoystickId(drone?.serialNumber || ''));
  
  // Use current connection status or saved status
  const isConnectedNow = connected || savedConnected;
  const displayJoystickId = joystickId || savedJoystickId;
    
  if (isConnectedNow && displayJoystickId) {
    return (
      <ArcStack>
        <ArcText.caption color='success' textAlign='center'> {displayJoystickId} is connected </ArcText.caption>
        <ArcStack p={4} direction='row' gap={2} justifyContent='space-between'>
          {axes.map((axis, idx) => (
            <ArcCellInfo key={idx} label={`axis ${idx}`}>
              {axis}
            </ArcCellInfo>
          ))}
        </ArcStack>
        <ArcDivider />

        <ArcStack p={4} direction='row' gap={2} flexWrap='wrap' justifyContent='space-between'>
          {buttons.map((button, idx) => (
            <ArcCellInfo key={idx} label={`button ${idx}`}>
              {button.value}
            </ArcCellInfo>
          ))}
        </ArcStack>
        <ArcDivider />
      </ArcStack>
    );
  }
  return <ArcText.caption color='brand.main' textAlign='center'> CONNECT YOUR GAMEPAD AND PRESS BUTTONS TO BEGIN </ArcText.caption> ;
};

export default JoystickView;